import { render, staticRenderFns } from "./control-buttons.vue?vue&type=template&id=4b995335&scoped=true"
import script from "./control-buttons.vue?vue&type=script&lang=js"
export * from "./control-buttons.vue?vue&type=script&lang=js"
import style0 from "./control-buttons.vue?vue&type=style&index=0&id=4b995335&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b995335",
  null
  
)

export default component.exports